"use client";
import { useState, type ReactNode } from "react";

import { cn } from "@perceptron/utils/cn";

/**
 * Fades a newly displayed asset in.
 *
 * The compositor hint is dropped once the fade has run. Left standing it keeps
 * the layer for as long as the asset is on screen, which on mobile is the rest
 * of the session; the hint is only worth anything while something is animating.
 *
 * Keyed by the caller on the displayed asset, so each one mounts its own fade.
 */
export function AssetFade({ children }: { children: ReactNode }) {
  const [fading, setFading] = useState(true);

  return (
    <div
      className={cn("asset-enter h-full w-full", fading && "asset-enter-fading")}
      onAnimationEnd={() => setFading(false)}
    >
      {children}
    </div>
  );
}
